import { Button } from '@mui/material'
import React, { useState } from 'react'

const LoadingWithFeedback = ({ action, disabled, children }) => {
  const [content, setContent] = useState(null)
  const actionHandler = () => {
    setContent('Cargando...')
    action()
      .then((res) => {
        if (!res?.error) setContent(<>&#x2713;</>)
      })
      .finally(() =>
        setTimeout(() => {
          setContent(null)
        }, 5000))
  }
  return (
    <Button disabled={disabled} onClick={actionHandler} >
      {content || children}
    </Button>
  )
}

export default LoadingWithFeedback
